module.exports = __webpack_public_path__ + "img/tuceng23.7c4b00ad.png";